"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "san-nicola-arcella": {
    "76c28463": [{
      "hkey": "18541441",
      "slug": "vannefora",
      "name": "Vannefora",
      "primary": true,
      "skipSearch": false
    }],
    "contrade-vannefora": [{
      "hkey": "18541441",
      "slug": "vannefora",
      "name": "Vannefora",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "00899891": [{
      "hkey": "bd953c6d",
      "slug": "san-nicola-arcella",
      "name": "San Nicola Arcella",
      "primary": true,
      "skipSearch": false
    }],
    "san-giorgio": [{
      "hkey": "bd953c6d",
      "slug": "san-nicola-arcella",
      "name": "San Nicola Arcella",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;